import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const MlaAddressLine2WUT = props => {
  const fieldType = FIELD_TYPES.MLA_ADDRESS_LINE_2;
  const label = useAddressLabel('addressLine2');
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    fieldType: fieldType,
    label: label
  }));
};
//# sourceMappingURL=mla-address-line-2-wut.js.map